import {
  BufferGeometry,
  Float32BufferAttribute,
  type Material,
  Mesh,
} from 'three';
import {
  buildGingivaMaterial,
  buildStepNumberMaterial,
  buildToothMaterial,
  buildWireMaterial,
} from './materials';

export function buildBufferGeometry(
  indices: number[],
  vertices: number[]
): BufferGeometry {
  const geometry = new BufferGeometry();
  geometry.setIndex(indices);
  geometry.setAttribute(
    'position',
    new Float32BufferAttribute(new Float32Array(vertices), 3)
  );
  geometry.computeVertexNormals();
  return geometry;
}

export function buildStepNumberMesh(
  indices: number[],
  vertices: number[],
  name: string
): Mesh {
  const geometry = buildBufferGeometry(indices, vertices);
  const mesh = new Mesh(geometry, buildStepNumberMaterial());
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  mesh.name = name; // TODO: Make sure nothing is relying on this being a number
  mesh.visible = false;
  return mesh;
}

export function buildWireMesh(
  indices: number[],
  vertices: number[],
  name: string
): Mesh {
  const geometry = buildBufferGeometry(indices, vertices);
  const mesh = new Mesh(geometry, buildWireMaterial());
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  mesh.name = name; // TODO: Make sure nothing is relying on this being a number
  mesh.visible = false;
  return mesh;
}

export function buildToothMesh(
  indices: number[],
  vertices: number[],
  name: string
): Mesh {
  const geometry = buildBufferGeometry(indices, vertices);
  const mesh = new Mesh(geometry, buildToothMaterial());
  mesh.castShadow = true;
  mesh.receiveShadow = false;
  mesh.name = name; // TODO: Make sure nothing is relying on this being a number
  return mesh;
}

export function buildGingivaMesh(
  indices: number[],
  vertices: number[],
  name: string
): Mesh {
  const geometry = buildBufferGeometry(indices, vertices);
  const mesh = new Mesh(geometry, buildGingivaMaterial());
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  mesh.name = name; // TODO: Make sure nothing is relying on this being a number
  return mesh;
}

export function replaceMeshMaterial(mesh: Mesh, material: Material): Mesh {
  const geometry = mesh.geometry.clone();
  const newMesh = new Mesh(geometry, material);
  newMesh.castShadow = mesh.castShadow;
  newMesh.receiveShadow = mesh.receiveShadow;
  newMesh.name = mesh.name;
  return newMesh;
}
